define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def",
	"csi/def/ActionFactory",
	"./ToolbarPluginButton",
	"./ToolbarPluginMenu"
], function(dojoDeclare,lang,csi,def,ActionFactory,ToolbarPluginButton,ToolbarPluginMenu) {

	var pluginRegistry = {};

	function _getActionClass(/*Action*/action, /*Context*/ctx, /*Boolean*/bMenu) {
		// summary: return class to use as plugin for action
		var bPop = ctx.push(action.m_path);
		var ctr;

		if (action.validate(ctx)) {
			if (action.classToolbarPlugin) {
				ctr = _getPluginClass(action.classToolbarPlugin, ctx);
			} else if (bMenu) {
				ctr = ToolbarPluginMenu;
			} else {
				// FIX: we currently don't support toggle buttons in menu - could use checked menu items?
				ctr = action.m_nameToggle ? pluginRegistry["ToolbarToggleButton"] : ToolbarPluginButton;
			}
		}

		if (bPop) {
			ctx.pop();
		}

		return ctr;
	}

	function _getPluginClass(/*String*/cls, /*Context*/ctx) {
		// summary: if plugin class found, then validate to see if it is valid for view
		var ctr = csi.syncRequire(cls);
		if (!ctr) {
			console.warn("PluginFactory.create: class not resolved - " + cls);
		}

		return ctr;
	}

	return {
		declare: function(/*String*/name, /*Object[]*/base, /*Object*/params) {
			// summary: declare class and register as plugin
			return pluginRegistry[name] = dojoDeclare(base, params);
		},

		create: function(/*Object*/params, /*Context*/ctx, /*Boolean*/bMenu) {
			// summary: find plugin class, validate that it belongs in view, and create
			var plugin = params.pluginName;
			var ctr;

			if (!params.defAction) {
				var cls;

				if (ctx.view.pluginClasses) {
					cls = ctx.view.pluginClasses[plugin];
				}

				if (cls = cls || pluginRegistry[plugin]) {
					// test to see if plugin is registered here
					ctr = _getPluginClass(cls, ctx);
				} else {
					// test to see if plugin is registered as action
					if (params.defAction = ActionFactory.newAction(plugin)) {
						params.defAction.resolve(null, ctx.defView.getRootClass(), null);
					} else {
						console.warn("PluginFactory.create: plugin not registered - " + plugin);
					}
				}
			}

			if (!ctr && params.defAction) {
				ctr = _getActionClass(params.defAction, ctx, bMenu);
			}

			// create toolbar widget
			if (!ctr) {
				return null;
			}

			if (ctr.prototype.validatePlugin && !ctr.prototype.validatePlugin(ctx)) {
				return null;
			}

			// add parameters for plugin stored on action
			if (params.defAction && params.defAction.classToolbarPluginParams) {
				lang.mixin(params, params.defAction.classToolbarPluginParams);
			}

			var tp = new ctr(params);

			// FIX: why not use postCreate?
			tp.postCreatePlugin(ctx);
			return tp;
		}
	};
});